import { render, staticRenderFns } from "./DealWorkflowChain.vue?vue&type=template&id=2109cf0c&scoped=true"
import script from "./DealWorkflowChain.vue?vue&type=script&lang=js"
export * from "./DealWorkflowChain.vue?vue&type=script&lang=js"
import style0 from "./DealWorkflowChain.vue?vue&type=style&index=0&id=2109cf0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2109cf0c",
  null
  
)

export default component.exports